import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const rawApiKey = process.env.BUGSNAG_FRONTEND_API_KEY;
const apiKey = rawApiKey && /^[0-9a-f]{32}$/i.test(rawApiKey) ? rawApiKey : null;

Bugsnag.start({
  apiKey: apiKey ?? '00000000000000000000000000000000',
  plugins: [new BugsnagPluginReact()],
  autoDetectErrors: false,
  enabledReleaseStages: apiKey ? undefined : [],
});

export default Bugsnag;
